import { useQuery } from "react-query";
import { fetchAPIShoppingBag } from "../requests/ShoppingBag";
import { ILoginData } from "../../../types/Login";
import logger from 'components/Logger'

export const API_SHOPPING_BAG_QUERY_KEY = 'apiShoppingBag'

export function useQueryShoppingBag(place_id:number,
                                    loginInfo:ILoginData | undefined,
                                    table: number,
                                    customQrCodeOrigin: number,
                                    whatsappIdentifier: string | undefined) {
  return useQuery(API_SHOPPING_BAG_QUERY_KEY,
    async () => {

      const result = await fetchAPIShoppingBag(place_id, loginInfo!.id, table, customQrCodeOrigin, whatsappIdentifier);
      logger.log('useQueryShoppingBag result = ', result.data)
      return result?.data;
    },
    {
    onSuccess: (data) => {},
      onError: () => { },
      enabled: !!loginInfo
  });
}
